import React, { useState } from "react";
import "./CookieConsentPopup.css";
import { Link } from "react-router-dom";

function CookieConsentPopup() {
    const [isPopupVisible, setPopupVisible] = useState(true);

    const handleAcceptCookies = () => {
        // Set a flag in localStorage to remember that the user accepted cookies
        localStorage.setItem("cookiesAccepted", "true");
        setPopupVisible(false);
    };

    if (!isPopupVisible) {
        return null; // Hide the popup if the user has already accepted cookies
    }

    return (
        <div className="CookieConsentPopup">
            <div className="cookie-popup">
                <p>
                    Our website uses cookies to ensure you get the best
                    experience. <a href="/privacy-policy">Read more.</a>
                </p>
                <div className="cookies-btns">
                    <button
                        onClick={handleAcceptCookies}
                        className="reject-cookies"
                    >
                        Reject All
                    </button>
                    <button
                        onClick={handleAcceptCookies}
                        className="accept-cookies"
                    >
                        Accept
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CookieConsentPopup;
